// BackgroundWorkMonitor — the „Zadania w tle” button + drawer and the upload-progress
// notice, mounted together once (inside AntdApp + ActionProvider + ProcessProvider).
// The notice steps aside while the drawer is open: it would cover the drawer's top,
// and the drawer already shows the same progress.
import React, { useState } from "react";
import { ActionMonitorButton } from "./ActionMonitor";
import { UploadProgressNotice } from "./UploadProgressNotice";

export const BackgroundWorkMonitor: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      <ActionMonitorButton onOpenChange={setDrawerOpen} />
      <UploadProgressNotice hidden={drawerOpen} />
    </>
  );
};
